import type { IRecipientListFormPost } from '~/types/adminRecipientList.js';

import { HTTP } from './HTTP.js';
export class RecipientListService {
  baseUrl: string;
  constructor() {
    this.baseUrl = `api/admin/schedule/sailing-schedule/share`;
  }

  index() {
    return HTTP.make(this.baseUrl, 'get');
  }

  store(data: IRecipientListFormPost) {
    return HTTP.make(this.baseUrl, 'post').data(data);
  }

  filters() {
    const path = `${this.baseUrl}/filters`;
    return HTTP.make(path, 'get');
  }

  show(id: string) {
    const path = `${this.baseUrl}/${id}/recipients`;
    return HTTP.make(path, 'get');
  }

  details(id: string) {
    const path = `${this.baseUrl}/${id}`;
    return HTTP.make(path, 'get');
  }

  edit(id: string) {
    const path = `${this.baseUrl}/${id}`;
    return HTTP.make(path, 'get');
  }

  update(id: string, data: IRecipientListFormPost) {
    const path = `${this.baseUrl}/${id}`;
    return HTTP.make(path, 'put').data(data);
  }

  destroy(id: string) {
    const path = `${this.baseUrl}/${id}`;
    return HTTP.make(path, 'delete');
  }

  emailPreview() {
    const path = `${this.baseUrl}/email-preview`;
    return HTTP.make(path, 'post');
  }

  sailingSchedule(reportId: string) {
    const baseUrl = `${this.baseUrl}/report/${reportId}`;

    return {
      index: () => {
        return HTTP.make(baseUrl, 'get');
      },
      indexMobile: () => {
        const path = `${baseUrl}/mobile`;
        return HTTP.make(path, 'get');
      },
      voyages: (trade: string) => ({
        index: () => {
          const path = `${baseUrl}/trade/${trade}`;
          return HTTP.make(path, 'get');
        },
      }),
    };
  }
}
